window.Bernie = window.Bernie || {};
var mod = require("-!/data/jenkins/workspace/blossom-flex-ui-master/node_modules/happypack/loader.js?id=ts!/data/jenkins/workspace/blossom-flex-ui-master/src/controllers/index.ts");
Object.keys(mod).forEach(function (key) { window.Bernie[key] = mod[key]; });
module.exports = window.Bernie;